import * as React from "react";
import { useDispatch } from "@teamprevent/admin-redux";
import { connect } from "react-redux";
import { isRequestActive } from "redux-request-loading";
import { Container, Loader, Table, Header } from "semantic-ui-react";
import moment = require("moment");
import { ImmunisationListModel } from "@teamprevent/common/immunisation/models";

import { EmployeeRecord } from "../../crud/employeeRecord";
import { ApplicationState } from "../../applicationState";
import { employeeImmunisationsSelector } from "../selectors";
import { routeIdSelector as employeeRecordIdSelector, employeeRecordSelector } from "../../crud/employeeRecord/selectors";
import { routeIdSelector as customerIdSelector } from "../../crud/customer/selectors";
import { loadEmployeeImmunisations } from "../actions";
import { loadEmployeeRecordDetail } from "../../crud/employeeRecord/actions";
import { LOAD_EMPLOYEE_RECORD_DETAIL } from "../../crud/employeeRecord/actiontypes";
import { LOAD_IMMUNISATIONS } from "../actionTypes";

import { ImmunisationRecordEmployeeDetails } from "./ImmunisationRecordEmployeeDetails";
import { ImmunisationRecordItem } from "./ImmunisationRecordItem";

interface Props {
    customerId: string;
    employeeRecordId: string;
    immunisations: ImmunisationListModel[];
    employeeDetails: EmployeeRecord;
    loading: boolean;
}

const ImmunisationRecordUnconnected: React.FC<Props> = (props) => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        (async () => {
            const loadImmunisations = dispatch(loadEmployeeImmunisations({ employeeRecordId: props.employeeRecordId }));
            const loadEmployeeRecord = dispatch(loadEmployeeRecordDetail({ customerId: props.customerId, employeeRecordId: props.employeeRecordId }));
            await Promise.all([loadImmunisations, loadEmployeeRecord]);
            setTimeout(() => print(), 500);
            window.addEventListener("afterprint", close);
        })();
    }, []);

    if (props.loading) {
        return <Container><Loader active /></Container>;
    }

    return (
        <Container className="immunisation-record">
            <Header>Personal Inoculation History</Header>
            <Header>PRIVATE AND CONFIDENTIAL</Header>
            <Container textAlign="right">Printed: {moment().format("DD/MM/YYYY HH:mm:ss")}</Container>
            <ImmunisationRecordEmployeeDetails employeeDetails={props.employeeDetails} />
            <Table>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Immunisation</Table.HeaderCell>
                        <Table.HeaderCell>Date Complete</Table.HeaderCell>
                        <Table.HeaderCell>Type</Table.HeaderCell>
                        <Table.HeaderCell>Outcome</Table.HeaderCell>
                        <Table.HeaderCell>IVS Sample</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {props.immunisations.map(immunisation =>
                        <ImmunisationRecordItem key={immunisation.id} item={immunisation} />
                    )}
                </Table.Body>
                <Table.Footer className={"immunisation-footer-record"}>
                    <p>
                        TP Health a subsidiary of <strong>Optima Health Plc.</strong> <br />
                        Our Registered Office is Meadow Court, 2 Hayland Street, Sheffield, England, S9 1BY. <br />
                        We are registered in England and Wales with Registered Number 5770728.
                    </p>
                </Table.Footer>
            </Table>
        </Container>
    );
};

const mapStateToProps = (state: ApplicationState): Props => ({
    customerId: customerIdSelector(state),
    employeeRecordId: employeeRecordIdSelector(state),
    immunisations: employeeImmunisationsSelector(state),
    employeeDetails: employeeRecordSelector(state),
    loading: isRequestActive(state, LOAD_EMPLOYEE_RECORD_DETAIL) || isRequestActive(state, LOAD_IMMUNISATIONS)
});

const ImmunisationRecord = connect(mapStateToProps)(ImmunisationRecordUnconnected);

export { ImmunisationRecord };
